var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoan4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H64C72.8366 0 80 7.16344 80 16V64C80 72.8366 72.8366 80 64 80H16C7.16344 80 0 72.8366 0 64V16Z",
    fill: "#EAE3FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4989_67333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5928 60.7321V52.5625H32.207C33.099 55.043 34.2438 57.1718 35.6348 58.6983C36.5859 59.7424 37.5829 60.4018 38.5928 60.7321Z",
    fill: "#9473F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5918 38.5H30.2004C30.0795 42.4865 30.4916 46.3488 31.3522 49.75H38.5918V38.5Z",
    fill: "#9473F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5703 49.75H61.7622C63.1278 46.7439 64.0016 43.4176 64.0016 39.9062V38.5H52.6138C52.7313 42.4635 52.373 46.3023 51.5703 49.75Z",
    fill: "#9473F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.792 52.5625H41.4062V60.7321C42.4161 60.4018 43.4132 59.7424 44.3643 58.6983C45.7553 57.1718 46.9001 55.043 47.792 52.5625Z",
    fill: "#9473F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7754 52.5625C49.723 55.8055 48.269 58.5884 46.4434 60.5921C44.9192 62.2644 43.1987 63.5402 41.4062 63.9005V64C49.3485 63.5344 56.2483 58.9307 60.2442 52.5625H50.7754Z",
    fill: "#9473F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7977 38.5H41.4062V49.75H48.6459C49.5064 46.3488 49.9186 42.4865 49.7977 38.5Z",
    fill: "#9473F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5918 63.9007C36.7993 63.5404 35.0788 62.2645 33.5547 60.5922C31.7291 58.5884 30.2751 55.8056 29.2227 52.5626H19.7539C23.7498 58.9308 30.6496 63.5345 38.5918 64V63.9007Z",
    fill: "#9473F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4313 49.75C27.6286 46.3023 27.2703 42.4635 27.3877 38.5H16V39.9062C16 43.4176 16.8737 46.7439 18.2393 49.75H28.4313Z",
    fill: "#9473F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 30.0625C43.8833 30.0625 47.0312 26.9145 47.0312 23.0312C47.0312 19.148 43.8833 16 40 16C36.1167 16 32.9688 19.148 32.9688 23.0312C32.9688 26.9145 36.1167 30.0625 40 30.0625Z",
    fill: "#9473F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5312 30.0625C27.6379 30.0625 30.1562 27.5441 30.1562 24.4375C30.1562 21.3309 27.6379 18.8125 24.5312 18.8125C21.4246 18.8125 18.9062 21.3309 18.9062 24.4375C18.9062 27.5441 21.4246 30.0625 24.5312 30.0625Z",
    fill: "#9473F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4688 30.0625C58.5754 30.0625 61.0938 27.5441 61.0938 24.4375C61.0938 21.3309 58.5754 18.8125 55.4688 18.8125C52.3621 18.8125 49.8438 21.3309 49.8438 24.4375C49.8438 27.5441 52.3621 30.0625 55.4688 30.0625Z",
    fill: "#9473F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3893 35.6875C62.2245 32.4208 59.1317 30.0625 55.47 30.0625C52.3169 30.0625 49.5955 31.8208 48.1473 34.3894C46.3747 31.7808 43.3854 30.0625 40.0013 30.0625C36.6173 30.0625 33.6279 31.781 31.8552 34.3894C30.4071 31.821 27.6854 30.0625 24.5325 30.0625C20.8708 30.0625 17.778 32.4208 16.6133 35.6875H63.3893Z",
    fill: "#9473F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4989_67333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoan4);
export default __webpack_public_path__ + "static/media/loan4.588ba1543241fd8d345bc30ba0e43299.svg";
export { ForwardRef as ReactComponent };